import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { setKaiser } from '../../actions/userActions';

@connect((store) => {
    return { isKaiserMember: store.user.isKaiserMember, date: store.meta.date };
})
class GenderSelect extends React.Component {

    componentDidMount() {
        console.log(this.props.date.getDay());
    }

    setKaiser(value) {
        this.props.dispatch(setKaiser(value));
        if (value === true) {
            this.props.history.push('/kaiser');
        } else {
            this.props.history.push('/novato');
        }
    }
    
    render() {
        return (
            <div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <h1 className="ec__font__title text-center">Are you a Kaiser Permanente member?</h1>
                    </div>
                </div>
                <div className="choices choices--small row">
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.setKaiser.bind(this, true)}>Yes</button>
                    </div>
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.setKaiser.bind(this, false)}>No</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default GenderSelect;


// WEBPACK FOOTER //
// ./src/components/screens/Female.js